import React from 'react'
import PropTypes from 'prop-types'
import isEmpty from 'lodash-es/isEmpty'
import moment from 'moment'
import Interweave from 'interweave'
import { convertMdToHtml } from '../index'
import Section from '../../Section'

const Changelog = ({ report: { reportContent } }) => (
  <Section title="Changelog">
    <Interweave
      content={convertMdToHtml.makeHtml(
        reportContent.summary.changeLogArray
          .map(value =>
            !isEmpty(value.date) && !isEmpty(value.description)
              ? `- ${value.date ? moment(value.date).format('YYYY-MM-DD') : 'N/A'} - ${
                  value.description
                }\n`
              : null,
          )
          .join(''),
      )}
    />
  </Section>
)

Changelog.propTypes = {
  report: PropTypes.object,
}

export default Changelog
